import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistEmploymentContractCase } from "../../Persist/EmploymentContractPersister";
import { stageMetaDataEmploymentLaw } from "../../Stages/StagesEmploymentContract";
import * as employmentContractStages from "../../Stages/StagesEmploymentContract";
import * as caseStatus from "../../LeadStatus/StatusCase";
import * as caseStages from "../../Stages/StagesCase";
import employmentContractTransformations from "../FormTransformations/employmentContractTransformations";
import { stageFormDefinition as stageFormDefinitionEmploymentContract } from "../FormDefinitions/employmentContract/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionEmploymentContract } from "../FormDefinitions/employmentContract/fullFormDefinition";
import employmentContractSpecificDefinition from "../FormDefinitions/employmentContract";
import { employmentContractDetailsSpecialActions } from "../CaseDetailsSpecialActions/employmentContractDetailsSpecialActions";
import { getLitigationCaseBadges } from "../Badges/getLitigationCaseBadges";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { getProductData } from "./productService";
import { EmploymentContract } from "../../../types/Products/EmploymentLaw/EmploymentContract";

export const employmentContract: ProductData<EmploymentContract> = {
  urlPart: "arbeitsvertrag",
  lbUrlPart: "arbeitsvertrag",
  label: translate("employmentContract.label"),
  generalLabel: translate("employmentContract.label"),
  apiUri: "employment_contracts",
  persist: persistEmploymentContractCase,
  stages: stageMetaDataEmploymentLaw,
  stageConstants: employmentContractStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\EmploymentLaw\\EmploymentContract\\EmploymentContract",
  formTransformations: employmentContractTransformations,
  formDefinition: ({ product, currentUser }) => stageFormDefinitionEmploymentContract(product, currentUser),
  formDefinitionExternals: ({ product }) => stageFormDefinitionEmploymentContract(product)[product.stage],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinitionEmploymentContract(product, currentUser),
  productSpecificDefinition: ({ product }) => employmentContractSpecificDefinition(product),
  caseDetailsSpecialActions: ({ product }) => employmentContractDetailsSpecialActions(product),
  productCategory: "employmentLaw",
  productSpecificBadges: ({ product }) => getLitigationCaseBadges(product),
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.employmentContract,
};
